import { ConfirmMfaSchema } from 'commons/login';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

// 多言語対応のためスキーマをフック化
export const useConfirmMfaSchema = () => {
  const { t } = useTranslationWithLang('commons');

  const schema = ConfirmMfaSchema({
    LengthMessage: (length: number) => t('Validate_Length', { length }),
    NumericMessage: t('Validate_Numeric'),
    RequiredMessage: t('Validate_Mfa_Required'),
  });
  return schema;
};
